<script>
  import Mask from 'svelte-input-mask';
  export let data;

  const mask = '+7 (000) 000-00-00';
  $: attributes = {
    name: data.key,
    class: 'input-phone',
    'aria-label': 'Введите номер телефона',
    type: 'tel',
  };
</script>

<div>
  <Mask {...attributes} {mask} />
  {#if data.required}
    <strong>*</strong>
  {/if}
</div>

<style lang="scss">
  div {
    :global(input) {
      letter-spacing: 2.5px;
    }
  }

  strong {
    position: absolute;
    top: 10px;
    right: 10px;
    color: rgb(255 99 71);
  }
</style>
